import { useTranslation } from 'react-i18next';
import { getOpenSourceLibraries } from '../../constants/utilityFunctions';
import { Paragraph } from '../Ant';
import styled from 'styled-components';
import { Flex } from 'antd';
import { stableScrollGutter } from '../../assets/styles/components/scrollGutter';

const SouceContainer = styled(Flex)`
  height: calc(var(--viewport-height) - 300px);
  overflow: hidden;
  overflow-y: auto;
  ${stableScrollGutter}
  ul {
    list-style-type: none;
    li {
      font-size: 12px;
      border-bottom: 1px solid var(--clr-border-grey-100);
      color: var(--clr-subtitle);
      line-height: 20px;
      padding-bottom: 4px;
      margin-bottom: 4px;
    }
  }
`;

const OpenSourceList = () => {
  const { t } = useTranslation();
  const dependencyList = getOpenSourceLibraries() ?? [];
  return (
    <SouceContainer vertical gap={15} className="resizable-modal-scroll">
      <Paragraph
        data-testid="open-source-explanation"
        $fontsize="12px"
        $lineheight="20px"
        $color="subtitle"
        dangerouslySetInnerHTML={{
          __html: String(t('common:profile.useOfOpenSourceExplanation')).replaceAll('\n', '<br/>'),
        }}
      ></Paragraph>
      {dependencyList?.length > 0 && (
        <ul>
          {dependencyList.map((val) => {
            return (
              <li key={val.name}>
                <a
                  data-testid={`open-source-link`}
                  href={val.repository}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {val.name}
                </a>
              </li>
            );
          })}
        </ul>
      )}
    </SouceContainer>
  );
};

export default OpenSourceList;
